import React from 'react'
import RoznicaCITRZiSHeaderStyle from '../../styles/RoznicaCITRZiSHeaderStyle'

const RoznicaCITRZiSHeader = () => {
  return (
    <RoznicaCITRZiSHeaderStyle shortenedView={true}>
      <div className="roznica-podatku-header">
        <div className="name">NAZWA POZYCJI</div>
        <div className="from">ROK POPRZEDNI</div>
        <div className="to">ROK BIEŻĄCY</div>
      </div>
    </RoznicaCITRZiSHeaderStyle>
  )
}

export default RoznicaCITRZiSHeader
